exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._2w1qc8fGC8TI7G8muvmhFj:before{content:\" ✂\";position:absolute;width:100%;text-align:center;cursor:pointer;font-size:18px;color:rgba(35,47,52,.75)}._2w1qc8fGC8TI7G8muvmhFj:hover{transition-property:color;transition-duration:150ms;transition-timing-function:ease-in-out}._2w1qc8fGC8TI7G8muvmhFj:hover:before{color:#5c9be4}", ""]);
// Exports
exports.locals = {
	"widget": "_2w1qc8fGC8TI7G8muvmhFj"
};